import { Injectable } from '@angular/core';
import { environment } from '../../../src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ReporteConstanciasM } from '../model/reporte-bean';

@Injectable({
  providedIn: 'root'
})
export class ReporteService {

  baseURL = environment.urlBase;

  userCons = environment.usuarioConstancias;
  passCons = environment.claveConstancias;
  constructor(private httpclient:HttpClient) {}

  getConstancias(P_X_CURSO : string,P_FECHA_INI: string,P_FECHA_FIN:string ): Observable<ReporteConstanciasM[]> {

    var url  : string;
    url = this.baseURL + 'reporte/api/constancias';

    let params = new HttpParams()
    .set('P_X_CURSO', P_X_CURSO)
    .set('P_FECHA_INI', P_FECHA_INI)
    .set('P_FECHA_FIN', P_FECHA_FIN);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.get<ReporteConstanciasM[]>(url, {headers:headers, params: params});

  }
  getTotalAlumnos(P_FECHA_INI: string,P_FECHA_FIN:string ): Observable<ReporteConstanciasM[]> {

    var url  : string;
    url = this.baseURL + 'reporte/api/totalalumnos';

    let params = new HttpParams()
    .set('P_FECHA_INI', P_FECHA_INI)
    .set('P_FECHA_FIN', P_FECHA_FIN);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<ReporteConstanciasM[]>(url, {headers:headers, params: params});

  }


  getVerificacion(P_DATO: string,P_FECHA:string,P_ESNRO:string ): Observable<ReporteConstanciasM> {

    var url  : string;
    url = this.baseURL + 'reporte/api/verificacion';

    let params = new HttpParams()
    .set('P_DATO', P_DATO)
    .set('P_FECHA', P_FECHA)
    .set('P_ESNRO', P_ESNRO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.get<ReporteConstanciasM>(url, {headers:headers, params: params});

  }
}
